// extracted by mini-css-extract-plugin
export default {"mdBox":"index_mdBox_TkiiH","title":"index_title_OI591","sofa":"index_sofa_ueHDY","join":"index_join_PLr3T","number":"index_number_bU4zi"};